import React, { useRef } from 'react';
import { Datagrid, TextField, useRefresh, useRecordContext } from 'react-admin';

import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import ListPageComum from '../../Components/ReactAdmin/List/ListPageComum';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { getListAllAPI } from '../../services';
import { STATUS_ATIVO, PRIMARY_COLOR } from '../../utils/constants';
import { PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR } from '../../utils/dadosTelas';
import DialogoVisualizarMapaLoja from '../EnderecoExposicaoMercadorias/DialogoVisualizarMapaLoja';
import Filter from './Filter';

function getLabelRepeticao(repeticao) {
  if (repeticao === 1) return 'Única';
  if (repeticao === 2) return 'Duplicado';
  if (repeticao === 3) return 'Triplicado';
  if (repeticao > 3) return 'Mais de 3';
  return 'NÃO EXPOSTO';
}

function getCoresRepeticao(repeticao) {
  if (repeticao === 1)
    return { bg: '#e8f5e9', borda: '#43a047', texto: '#2e7d32' };
  if (repeticao === 2)
    return { bg: '#e3f2fd', borda: '#1e88e5', texto: '#1565c0' };
  if (repeticao === 3)
    return { bg: '#fff3e0', borda: '#fb8c00', texto: '#e65100' };
  if (repeticao > 3)
    return { bg: '#f3e5f5', borda: '#8e24aa', texto: '#6a1b9a' };
  return { bg: '#fdecea', borda: '#d32f2f', texto: '#d32f2f' };
}

const EnderecosField = (props) => {
  const record = useRecordContext(props);
  const enderecos =
    record && record.record ? record.record.enderecos_exposicao : [];

  if (!enderecos || enderecos.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {enderecos.map((codigo) => (
        <Chip key={codigo} size="small" label={codigo} />
      ))}
    </div>
  );
};

const StatusField = (props) => {
  const record = useRecordContext(props);
  const repeticao_exposicao_na_loja = record
    ? record.record
      ? record.record.repeticao_exposicao_na_loja
      : 0
    : 0;

  const cores = getCoresRepeticao(repeticao_exposicao_na_loja);

  return (
    <Chip
      size="small"
      label={getLabelRepeticao(repeticao_exposicao_na_loja)}
      style={{
        backgroundColor: cores.bg,
        color: cores.texto,
        border: `1px solid ${cores.borda}`,
        fontWeight: 600,
      }}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: PRIMARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: 'red',
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: 'red !important',
    },
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const List = (props) => {
  const refDialogoConfirmacao = useRef(null);
  const refDialogoMapa = useRef(null);
  const refresh = useRefresh();
  const classes2 = useStyles();

  const handleClose = () => {
    refresh();
  };

  async function handleVerNoMapa(record) {
    const { data } = await getListAllAPI(
      'mapas_loja',
      ['id', 'asc'],
      { nome: 'Mapa Principal' },
      [],
    );
    if (data.length === 0) return;
    if (refDialogoMapa.current) {
      refDialogoMapa.current.handleOpen(data[0].id, {
        id: record.id,
        nome: record.nome,
      });
    }
  }

  const toolbarActions = <ActionsList {...props} />;

  const renderGrid = ({ listProps, classes, listContext }) => (
    <Datagrid {...props}>
      <TextField
        source="nome"
        label="Produto"
        headerClassName={classes2.dataHeader}
        cellClassName={classes2.dataCell}
      />
      {/* <ReferenceField
        label="Produto"
        source="produto_id"
        reference="produtossearch"
        sortable={false}
        linkType={false}
      >
        <TextField source="nome" />
      </ReferenceField> */}
      <StatusField
        label="Exposição"
        source="produto_id"
        sortable={false}
        headerClassName={classes2.dataHeader}
        cellClassName={classes2.dataCell}
      />
      <EnderecosField
        label="Endereços de Exposição"
        source="enderecos_exposicao"
        sortable={false}
        headerClassName={classes2.dataHeader}
        cellClassName={classes2.dataCell}
      />
      <ActionsField
        textAlign="right"
        label="Ações"
        sortable={false}
        headerClassName={classes2.dataHeader}
        cellClassName={classes2.dataCell}
        actions={[
          {
            title: 'Ver no Mapa',
            icon: <MapOutlinedIcon />,
            show: () => true,
            onClick: (r) => handleVerNoMapa(r),
          },
        ]}
      />
    </Datagrid>
  );

  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR}>
      <ListPageComum
        title="Produtos Expostos"
        filters={<Filter />}
        toolbarActions={toolbarActions}
        renderGrid={renderGrid}
        perPage={50}
        listProps={props}
        filterDefaultValues={{ status: STATUS_ATIVO }}
      />
      <DialogoVisualizarMapaLoja
        ref={refDialogoMapa}
        andarFiltro={1}
        titulo="Térreo"
      />
    </ProtegerPagina>
  );
};

export default List;
